// extracted by mini-css-extract-plugin
export default {"slugContainer":"src-pages-SalesChannelContentEditor-SalesChannelContentPage-EditorPage-SEOSetting-css-module__slugContainer--US2qw"};